import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const departmentService = {
  get_list_department: (token, params = {}) => {
    const uri = API_ROUTES.DEPARTMENT.GET_LIST_DEPARTMENT;
    return https.get(uri, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  get_list_department_short: (token, params = {}) => {
    const uri = API_ROUTES.DEPARTMENT.GET_LIST_DEPARTMENT_SHORT;
    return https.get(uri, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  get_detail_department: (token, departmentId) => {
    const uri = `${API_ROUTES.DEPARTMENT.GET_DETAIL_DEPARTMENT.replace(
      ":departmentId",
      departmentId
    )}`;
    return https.get(uri, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  update_department: (token, departmentId, data) => {
    const uri = API_ROUTES.DEPARTMENT.UPDATE_DEPARTMENT.replace(
      ":departmentId",
      departmentId
    );
    return https.put(uri, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  delete_department: (token, departmentId) => {
    const uri = API_ROUTES.DEPARTMENT.DELETE_DEPARTMENT.replace(
      ":departmentId",
      departmentId
    );
    return https.delete(uri, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  create_department: (token, data) => {
    const uri = API_ROUTES.DEPARTMENT.CREATE_DEPARTMENT;
    return https.post(uri, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
